module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.description),
      expression: "entity.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "type": "text",
      "placeholder": "Enter description"
    },
    domProps: {
      "value": (_vm.entity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.country),
      expression: "entity.address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "country",
      "type": "text",
      "placeholder": "Enter country"
    },
    domProps: {
      "value": (_vm.entity.address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.state),
      expression: "entity.address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "state",
      "type": "text",
      "placeholder": "Enter state"
    },
    domProps: {
      "value": (_vm.entity.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.city),
      expression: "entity.address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "city",
      "type": "text",
      "placeholder": "Enter city"
    },
    domProps: {
      "value": (_vm.entity.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.address),
      expression: "entity.address.address"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "address",
      "type": "text",
      "placeholder": "Enter address"
    },
    domProps: {
      "value": (_vm.entity.address.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "postal_code"
    }
  }, [_vm._v("Zip/Postal code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.postal_code),
      expression: "entity.address.postal_code"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "postal_code",
      "type": "text",
      "placeholder": "Enter postal code"
    },
    domProps: {
      "value": (_vm.entity.address.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "postal_code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "organisation_name"
    }
  }, [_vm._v("Organisation name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.organisation_name),
      expression: "entity.address.organisation_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "organisation_name",
      "type": "text",
      "placeholder": "Enter organisation name"
    },
    domProps: {
      "value": (_vm.entity.address.organisation_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "organisation_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "fax"
    }
  }, [_vm._v("Fax")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.fax),
      expression: "entity.contacts.fax"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fax",
      "type": "text",
      "placeholder": "Enter fax"
    },
    domProps: {
      "value": (_vm.entity.contacts.fax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "fax", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.email),
      expression: "entity.contacts.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "text",
      "placeholder": "Enter email"
    },
    domProps: {
      "value": (_vm.entity.contacts.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.phone),
      expression: "entity.contacts.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone",
      "type": "text",
      "placeholder": "Enter phone"
    },
    domProps: {
      "value": (_vm.entity.contacts.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "website"
    }
  }, [_vm._v("Website")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.website),
      expression: "entity.contacts.website"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "website",
      "type": "text",
      "placeholder": "Enter website"
    },
    domProps: {
      "value": (_vm.entity.contacts.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "website", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Geocode")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.geocode.lat),
      expression: "entity.geocode.lat"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter latitude"
    },
    domProps: {
      "value": (_vm.entity.geocode.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.geocode, "lat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.geocode.lon),
      expression: "entity.geocode.lon"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter longitude"
    },
    domProps: {
      "value": (_vm.entity.geocode.lon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.geocode, "lon", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 offset-md-2"
  }, [(_vm.entity.geocode) ? _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "350px",
      "margin-top": "20px"
    },
    attrs: {
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom
    },
    on: {
      "click": _vm.mapClick
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.entityMapCenter
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Location has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Location")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dba0021","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/content/locations/New.vue
// module id = 957
// module chunks = 0